<section>
  @if (screenMode === 'LIST') {
    <div class="rules-header">
      <div class="row">
        <div class="col-12 col-lg-10">
          <h5 class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'RulesManagement' | translate }}
              <app-help tooltipKey="RulesManagementTooltip" tooltipPlacement="bottom" />
            </div>
          </h5>
          <p class="mt-1">{{ 'AccessControlDescription' | translate }}</p>
        </div>
        <div class="col-12 col-lg-2 d-flex justify-content-lg-end">
          @if (editMode) {
            <button
              (click)="rollbackEdit()"
              [disabled]="screenMode !== 'LIST'"
              class="btn btn-sm btn-danger btn-restricted-height mr-2"
            >
              {{ 'Annuler' | translate }}
            </button>
            <button
              (click)="commitEdit()"
              [disabled]="screenMode !== 'LIST'"
              class="btn btn-sm btn-primary btn-restricted-height"
            >
              {{ 'Valider' | translate }}
            </button>
          } @else {
            <button (click)="toggleEditMode()" class="btn btn-sm btn-primary btn-restricted-height">
              {{ 'Modifier' | translate }}
            </button>
          }
        </div>
      </div>
    </div>

    <div *ngIf="site && disabled" class="bg-blue" style="margin-bottom: 10px; margin-top: -10px">
      {{ 'SubscribeTo.advanced' | translate }}
    </div>

    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th></th>
            <th class="cell-active">
              {{ 'Active' | translate }}
              <app-help tooltipKey="RuleActiveTooltip" tooltipPlacement="right" />
            </th>
            <th class="cell-priority">
              {{ 'Priority' | translate }}
              <app-help tooltipKey="RulePriorityTooltip" tooltipPlacement="right" />
            </th>
            <th class="cell-paths">
              {{ 'Paths' | translate }}
            </th>
            <th class="cell-description">
              {{ 'Rule.actions.label' | translate }}
              <app-help tooltipKey="RuleConfigurationTooltip" tooltipPlacement="right" />
            </th>
            <th class="cell-comment">{{ 'Comments' | translate }}</th>
            <th class="cell-action">{{ 'Actions' | translate }}</th>
          </tr>
        </thead>
        <tbody (cdkDropListDropped)="drop($event)" cdkDropList>
          @if (displayedRules?.length) {
            @for (rule of displayedRules; track rule) {
              <tr [cdkDragDisabled]="!editMode" cdkDrag cdkDragLockAxis="y" class="drag-box">
                <td>
                  <app-table-grip [disabled]="!editMode" />
                </td>
                <td class="cell-active">
                  <app-switch
                    (change)="dirtyState.setDirty()"
                    [(ngModel)]="rule.active"
                    [disabled]="!editMode"
                    [showLabels]="false"
                  />
                </td>
                <td class="cell-priority">#{{ $index + 1 }}</td>
                <td class="cell-paths">
                  <ul class="path-list">
                    @for (p of rule.paths; track p) {
                      <li class="path">{{ p }}</li>
                    }
                  </ul>
                </td>

                <td class="cell-description">
                  <span
                    >{{ 'Rule.ipFilter' | translateLabel }}
                    {{ 'Rule.defaultPolicy.' + rule.defaultPolicy | translate }}</span
                  >
                  @if (rule.ipExceptions.length) {
                    <span>, </span> {{ 'Rule.ipExceptions.label.' + rule.defaultPolicy | translateLabel
                    }}<button
                      class="icofont icofont-ui-copy"
                      (click)="copyIpExceptionsToClipboard(rule.ipExceptions)"
                    ></button>
                    <ul class="ip-list">
                      @for (ip of rule.ipExceptions; track ip) {
                        <li>{{ ip }}</li>
                      }
                    </ul>
                  }

                  @if (clusterConfig.supportsCache && site.cacheEnabled) {
                    <div>{{ 'AccessControlRules.Cache.' + (rule.cache ? 'enabled' : 'disabled') | translate }}</div>
                  }

                  <div>{{ 'AccessControlRules.' + ruleAction[rule.action] | translate }}</div>

                  @if (clusterConfig.supportsChallenge) {
                    <div>
                      {{ 'Challenge.label' | translate }} : {{ 'Challenge.Type.' + rule.challenge | translate }}
                    </div>
                  }
                  @if (rule.customPagesProfile) {
                    <div>{{ 'ErrorHandler.selected' | translate }} : {{ rule.customPagesProfile.name }}</div>
                  }
                </td>
                <td class="cell-comment">
                  {{ rule.comment }}
                </td>
                <td class="cell-action">
                  <div class="icon-container">
                    <button
                      (click)="prepareUpdate($index)"
                      [disabled]="!editMode"
                      class="icofont icofont-edit-alt"
                    ></button>
                    <button (click)="delete(rule)" [disabled]="!editMode" class="icofont icofont-ui-delete"></button>
                  </div>
                </td>
              </tr>
            }
          } @else {
            <tr>
              <td class="text-center py-3" colspan="8">
                {{ 'NoRules' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (editMode) {
        <a (click)="prepareCreate()" class="ogo-link"> + {{ 'AddARule' | translate }} </a>
      }
    </div>
  }
  @if (screenMode != 'LIST') {
    <app-rules-details
      [rule]="editedRule"
      [siteName]="siteName"
      [priority]="editedIndex"
      (validate)="validateRule($event)"
      (cancel)="cancelEdit()"
      [clusterConfig]="clusterConfig"
      [siteCacheEnabled]="site.cacheEnabled"
    />
  }
</section>
